import { useAtomValue } from 'jotai';
import { SettingsIcon } from 'lucide-react';
import { ArrowRightIcon } from 'lucide-react';
import { Activity } from 'react';

import { Stack } from '@crossnokaye/ux-common';

import { JumpToEquipmentButton } from '@/features/equipment-browser/equipment-browser-page/components/buttons/jump-to-equipment-button';
import { displaySettingsListAtom } from '@/features/equipment-browser/equipment-details/state/display-settings.state';
import { equipmentLoadingAtom } from '@/features/equipment-browser/equipment-details/state/equipment-response.state';
import {
  activeSequencerAtom,
  activeSequencerDisplaySettingsListAtom,
} from '@/features/equipment-browser/equipment-details/state/sequencers.state';
import { SectionTemplate } from '@/features/equipment-browser/equipment-details/templates/section-template';

import { GeneralSettings } from './components/general-settings';
import { SequencerSettings } from './components/sequencer-settings';

export const EquipmentDetailsSettings = (): React.ReactNode => {
  const isLoading = useAtomValue(equipmentLoadingAtom);
  const settings = useAtomValue(displaySettingsListAtom);

  const activeSequencer = useAtomValue(activeSequencerAtom);
  const activeSequencerDisplaySettings = useAtomValue(activeSequencerDisplaySettingsListAtom);

  const hasSequencerSettings = !!activeSequencer && activeSequencerDisplaySettings.length > 0;

  return (
    <SectionTemplate
      title={'Settings'}
      icon={SettingsIcon}
      isLoading={isLoading}
      rightButtons={
        <JumpToEquipmentButton
          equipmentId={activeSequencer?.deviceId}
          className="btn btn-tier2 btn-sm"
        >
          {'Sequencer'}
          <ArrowRightIcon className="btn-icon" aria-hidden="true" />
        </JumpToEquipmentButton>
      }
    >
      <Stack gap="thin">
        <GeneralSettings settings={settings} />
        <Activity mode={hasSequencerSettings ? 'visible' : 'hidden'}>
          <SequencerSettings settings={activeSequencerDisplaySettings} />
        </Activity>
      </Stack>
    </SectionTemplate>
  );
};
